<!--
 * @Date: 2023-01-31 15:59:27
 * @LastEditTime: 2026-05-20 11:05:44
 * @Description: 
 * @FilePath: \lsz-user-mp\src\views\user\checkout\list.vue
-->
<template>
  <div>
    <patientAllSelect @onConfirm="patientConfirm" />
    <div class="empty-text">
      <span style="color: #666;">可查询范围：所有门诊检验报告。</span> <br>
      <span>温馨提示：所有报告请于报告完成的第二日再进行查询</span>
    </div>
    <load-more
      :data-source="dataList"
      :total="total"
      :loading="loading"
      @load-more="onLoad"
    >
      <CheckoutItem :pat-id="String(patientId)" :data="dataList" />
    </load-more>
  </div>
</template>
<script>
//  import { userModel } from '@/api/user'
import loadMore from "@/assets/js/mixin/load-more"
import CheckoutItem from "@/components/checkoutItem/checkoutItem.vue"
import { patientModel } from "../../../api/patient"

export default {
  name: "List",
  components: {
    CheckoutItem
  },
  mixins: [loadMore],
  data() {
    return {
      // dataList:[1,2]
      dataList: [],
      page: 1,
      pageSize: 10,
      patientId:'',
      // patxm: "",
      // zjh: "",
      total: 0,
      loading: false
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      if (this.patientId == "") {
        return
      }
      let params = {
        isPatAll: "0",
        page: this.page,
        pageSize: this.pageSize,
        patientId: this.patientId
        // patxm: this.patxm,
        // zjh: this.zjh
      }
      patientModel.inspectionReportList(params).then((res) => {
        const newData = res.data || []
        if (this.page === 1) {
          // 首次加载或重置时，直接替换数据
          this.dataList = newData
        } else {
          // 加载更多时，追加数据
          this.dataList = [...this.dataList, ...newData]
        }
        this.total = res.count
      }).finally(() => {
        this.loading = false
      })
    },
    patientConfirm(value) {
      console.log('value------', value)
      this.patientId = value.id
      // this.patxm = value.text
      // this.zjh = value.zjh
      this.page = 1
      this.dataList = []
      this.loading = true
      this.getList()
    },
    onLoad() {
      this.loading = true
      this.page += 1
      this.getList()
    }
  }
}
</script>
<style scoped>
.empty-text {
  padding: 10px;
  /* text-align: center; */
  font-size: 22px;
  color: #DC3030 !important;
}

</style>
